"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const services_1 = require("@zapier/services");
const isInstantServiceAction_1 = __importDefault(require("./isInstantServiceAction"));
const nodeAction = (node, services) => {
    if (!node)
        return undefined;
    const _service = services_1.getAssociatedService(node, services) || {};
    return lodash_1.default.find(_service[node.type_of], { key: node.action });
};
const isInstant = (node, services) => {
    const action = nodeAction(node, services) || {};
    return isInstantServiceAction_1.default(action);
};
exports.default = isInstant;
